import { initializeApp, getApps } from 'firebase/app'
import { getAuth,applyActionCode } from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'
import { getStorage } from 'firebase/storage'
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions'
import {
    getToken,
    getMessaging,
    onMessage,
    isSupported,
} from 'firebase/messaging'
import { message } from 'antd'

// Firebase configuration for the chatbot app
const firebaseConfigChatBot = {
    apiKey: process.env.REACT_APP_API_KEY,
    authDomain: process.env.REACT_APP_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_PROJECT_ID,
    storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_API_ID,
    measurementId: process.env.REACT_APP_MEASUREMENT_ID,
}

// Initialize Firebase apps

const appChatBot =
    getApps().find((app) => app.name === 'chatbot') ||
    initializeApp(firebaseConfigChatBot, 'chatbot')

export const authChatBot = getAuth(appChatBot)
export const dbChatBot = getFirestore(appChatBot)
export const functions = getFunctions(appChatBot, 'asia-south1')
export const storageChatBot = getStorage(appChatBot)
const messaging = getMessaging(appChatBot)

export async function getFcmToken() {
    try {
        if (Notification.permission === 'granted') {
            const token = await getToken(messaging, {
                vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY,
            })
            return token
        } else if (Notification.permission === 'default' || Notification.permission === 'denied') {
            const permission = await Notification.requestPermission()
            if (permission === 'granted') {
                const token = await getToken(messaging, {
                    vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY,
                })
                return token
            } else {
                message.error('User denied notification permission. Please check  your browser settings and enable notifications')
                return null
            }
        } else {
            console.warn('Notifications are blocked by the browser.')
            return null
        }
    } catch (err) {
        console.error('FCM token error:', err)
        return null
    }
}
//
const notificationChannel = new BroadcastChannel('notification-channel')

let isActiveTab = false

function checkActiveTab() {
    if (document.visibilityState === 'visible') {
        notificationChannel.postMessage({ type: 'ACTIVE_TAB' })
        isActiveTab = true
    } else {
        isActiveTab = false
    }
}

document.addEventListener('visibilitychange', checkActiveTab)

checkActiveTab()

notificationChannel.onmessage = (event) => {
    if (event.data.type === 'ACTIVE_TAB') {
        if (document.visibilityState !== 'visible') {
            isActiveTab = false
        }
    }
}

onMessage(messaging, (payload) => {
    const { title, body } = payload.notification
    const { type } = payload.data
    if (isActiveTab) {
        if (Notification.permission === 'granted') {
            const notification = new Notification(title, {
                body,
                icon: '/images/Bianat.png',
            })
            notification.onclick = (event) => {
                event.preventDefault()
                console.log('Notification clicked!', payload)
                window.open(
                    `${process.env.REACT_APP_BASE_URL}dashboard`,
                    '_blank'
                )
            }
        }
    }
})
notificationChannel.onmessage = (event) => {
    console.log('Notification handled in another tab. Skipping.', event)
}
//connectFunctionsEmulator(functions, '127.0.0.1', 5001)
